module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img507-42ab8a55633ef0c8bfd5a42fc538f528.jpg";